import { useEffect } from "react";

export function useResetTabs(
    setActiveTab: (tab: number) => void,
    setActiveSubTab: (tab: number) => void
) {
    useEffect(() => {
        setActiveTab(0);
        setActiveSubTab(0);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
